import { gql } from '@apollo/client'

export const CurrentIntakeQuery = gql`
    query CurrentIntake($candidateIntakeId: ID!) {
        currentIntake(candidateIntakeId: $candidateIntakeId) {
            id
            intakeId
            candidate {
                currentWorkExperience {
                    id
                    company {
                        id
                        value
                    }
                    companyOffice {
                        officeLocation {
                            value
                        }
                    }
                    title {
                        value
                    }
                    startDate
                    endDate
                    workEmail
                    workPhone
                    industries {
                        industry {
                            value
                        }
                    }
                    sectors {
                        sector {
                            value
                        }
                    }
                }
            }
            intake {
                id
                displayName
                internalName
                intakePartId
                intakePart {
                    id
                    internalName
                    order
                }
                questions {
                    id
                    intakeId
                    order
                    displayName
                    internalName
                    questionData {
                        ... on AnalystsQuestion {
                            skip
                            subtext
                            prompt
                        }
                        ... on CountryHometownQuestion {
                            skip
                            subtext
                            prompt
                            countryChoices {
                                choice
                                bucket
                            }
                            provinceChoices {
                                choice
                                bucket
                            }
                            stateChoices {
                                choice
                                bucket
                            }
                        }
                        ... on DatePickerQuestion {
                            skip
                            subtext
                            prompt
                            label
                            repeat
                        }
                        ... on DropdownQuestion {
                            skip
                            subtext
                            prompt
                            choices {
                                choice
                                bucket
                            }
                            label
                            repeat
                        }
                        ... on DropdownMultiSelectQuestion {
                            skip
                            subtext
                            prompt
                            choices {
                                choice
                                bucket
                            }
                            limit
                            label
                            repeat
                        }
                        ... on EmploymentQuestion {
                            skip
                            subtext
                            prompt
                            companyChoices {
                                choice
                                bucket
                            }
                            workTitles
                            industryChoices {
                                choice
                                bucket
                            }
                            sectorChoices {
                                choice
                                bucket
                            }
                        }
                        ... on GraduateDegreeQuestion {
                            skip
                            subtext
                            prompt
                            collegeChoices {
                                value
                            }
                            mbaCollegeChoices {
                                value
                            }
                            degreeChoices {
                                choice
                                bucket
                            }
                            gpaChoices {
                                choice
                                bucket
                            }
                            gpaScaleChoices
                        }
                        ... on InternshipQuestion {
                            skip
                            subtext
                            prompt
                            companyChoices {
                                choice
                                bucket
                            }
                            industryChoices {
                                choice
                                bucket
                            }
                            sectorChoices {
                                choice
                                bucket
                            }
                            officeLocations
                        }
                        ... on MultipleChoiceQuestion {
                            skip
                            subtext
                            prompt
                            choices {
                                choice
                                bucket
                            }
                        }
                        ... on MultipleResponseQuestion {
                            skip
                            subtext
                            prompt
                            multiResponseChoices {
                                choice
                                bucket
                            }
                        }
                        ... on ReferenceQuestion {
                            skip
                            subtext
                            prompt
                            companyChoices {
                                choice
                                bucket
                            }
                            workTitles
                        }
                        ... on StafferQuestion {
                            skip
                            subtext
                            prompt
                            workTitles
                        }
                        ... on StandardizedTestScoresQuestion {
                            skip
                            subtext
                            prompt
                        }
                        ... on UndergraduateCollegeQuestion {
                            skip
                            subtext
                            prompt
                            collegeChoices {
                                value
                            }
                            majorChoices {
                                choice
                                bucket
                            }
                            gpaChoices {
                                choice
                                bucket
                            }
                            gpaScaleChoices
                        }
                    }
                    questionType
                    isActive
                }
            }
            completionDate
        }
    }
`

export const SubmitIntake = gql`
    mutation SaveAnswers($input: CandidateAnswersInput!) {
        saveAnswers(input: $input) {
            records {
                candidateIntakeId
            }
        }
    }
`
